import { Check } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { whoThisIsFor, WHO_IMG } from "../../data/academyData";

export const WhoThisIsFor = () => (
  <section id="who" data-testid="who-this-is-for-section" className="relative py-20 md:py-32 bg-[#08080A] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5]">
          <img src={WHO_IMG} alt="Couple embracing at golden hour, symbolising the transformation AX Academy members experience" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold mb-4">Is This For You?</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-tight">AX Academy Is For You If…</h2>
        </Reveal>
        <div className="mt-10 space-y-4">
          {whoThisIsFor.map((item, i) => (
            <Reveal key={item} delay={i * 0.04}>
              <div className="flex items-start gap-4 p-5 rounded-xl bg-white/[0.03] border border-white/10" data-testid={`who-item-${i}`}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-400"><Check size={15} /></span>
                <span className="text-zinc-200 text-base">{item}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
